import React from 'react';

/**
 * Renders the appropriate media preview based on file type
 */
const MediaPreview = ({ data, zoom = 1 }) => {
  if (!data) return null;

  const { previewUrl, fileType, filename } = data;

  return (
    <>
      {fileType === 'image' && (
        <div className="preview-panel__image-container">
          <img
            src={previewUrl}
            alt={filename}
            className="preview-panel__image"
            style={{ transform: `scale(${zoom})` }}
            draggable={false}
          />
        </div>
      )}

      {fileType === 'pdf' && (
        <iframe
          src={previewUrl}
          className="preview-panel__pdf"
          title={filename}
        />
      )}

      {fileType === 'video' && (
        <video
          src={previewUrl}
          className="preview-panel__video"
          controls
          autoPlay={false}
        />
      )}

      {fileType === 'audio' && (
        <div className="preview-panel__audio-container">
          <div className="preview-panel__audio-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M9 18V5l12-2v13" />
              <circle cx="6" cy="18" r="3" />
              <circle cx="18" cy="16" r="3" />
            </svg>
          </div>
          <audio
            src={previewUrl}
            className="preview-panel__audio"
            controls
          />
        </div>
      )}
    </>
  );
};

export default MediaPreview;
